export default __webpack_public_path__ + "static/media/oldfog2.174f208d.png";